module.exports = __webpack_public_path__ + "static/media/uoa-4.f364b0d3.jpg";